import IconUserSolid from '@/assets/icons/font_awesome/user-solid.svg?react';
import { UI_PRIMITIVE__icon_animated } from '@/components/ui/UI_PRIMITIVE__icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { get_sorted_current_workspace_users } from '@/utils/utils_workspace';
import { useTranslation } from 'react-i18next';
import { UserAvatarReadOnly } from '../../_base/UserAvatarReadOnly';

export function WSTableUserCreditLimitsHeader() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  function render_header() {
    const users = get_sorted_current_workspace_users();

    let header_users = users.map(user => {
      return (
        <span
          key={`WSTableUserCreditLimitsHeader_${user._id}`}
          className={`${md('min-w-[40px] text-[12px]', 'min-w-[100px] h-[50px]')}  flex flex-col gap-2 items-center justify-center ${
            user.user_id == current_workspace_user.user_id ? 'border-r border-dashed border-component-item' : ''
          }
          `}
        >
          <UserAvatarReadOnly url_relative={user.url_relative_avatar} userName={user.full_name} className="!w-5 !h-5" />
        </span>
      );
    });

    return (
      <>
        <span
          key={`WSTableUserCreditLimitsHeader_${1}`}
          className={`${md(
            'min-w-[40px] text-[12px]',
            'min-w-[100px] h-[50px]',
          )} border-r border-dashed border-component-item flex flex-col gap-2 items-center justify-center`}
        >
          <UI_PRIMITIVE__tooltip delay_duration={0} tooltip_title={t(i18n_page_settings_workspace.tabs.features_access.icon.template_new_user.tooltip)}>
            <UI_PRIMITIVE__icon_animated
              className="!size-4 hover-animation-important text-component-item-foreground hover:text-bar-foreground"
              renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
              Icon={IconUserSolid}
            />
          </UI_PRIMITIVE__tooltip>
        </span>
        {header_users}
      </>
    );
  }

  return render_header();
}
